import { render, staticRenderFns } from "./integralDetails.vue?vue&type=template&id=03aa4b6e&scoped=true"
import script from "./integralDetails.vue?vue&type=script&lang=ts"
export * from "./integralDetails.vue?vue&type=script&lang=ts"
import style0 from "./integralDetails.vue?vue&type=style&index=0&id=03aa4b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aa4b6e",
  null
  
)

export default component.exports